<template>
    <tool-panel ref="panel" @close="$emit('close')">
        <template #header>
            <tool-panel-header
                :title="$t('about.title')"
                :fullscreen="$refs.panel?.isFullscreen"
                @toggle-fullscreen="$refs.panel.toggleFullscreen()"
                @close="$refs.panel.close()"
            />
        </template>
        <div class="about-body">
            <h3 class="mt-2">{{ $t('about.contact_title') }}</h3>
            <span>routa@sitowise.com</span>
            <br><br>
            <h3>{{ $t('about.manuals_title') }}</h3>
            <br/>
            <span>{{ $t('about.manuals_hint') }}</span>
            <div v-if="visibleMobileManuals.length > 0" class="nopads">
                <h4>{{ $t('about.manuals_mobile') }}</h4>
                <table class="table table-hover table-responsive" style="background: #ffffff; cursor: pointer">
                    <thead><tr>
                        <th style="width: 50%">{{ $t('about.manual_title') }}</th>
                        <th style="width: 50%">{{ $t('about.description') }}</th>
                    </tr></thead>
                    <tbody>
                    <tr v-for="(manual, index) in visibleMobileManuals" :key="index" @click="openFileFromAssets(manual)">
                        <td>{{ manual.filename }}</td>
                        <td>{{ manual.description }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="visibleWebManuals.length > 0" class="nopads">
                <h4>{{ $t('about.manuals_browser') }}</h4>
                <table class="table table-hover table-responsive" style="background: #ffffff; cursor: pointer">
                    <thead><tr>
                        <th style="width: 50%">{{ $t('about.manual_title') }}</th>
                        <th style="width: 50%">{{ $t('about.description') }}</th>
                    </tr></thead>
                    <tbody>
                    <tr v-for="(manual, index) in visibleWebManuals" :key="index" @click="openFileFromAssets(manual)">
                        <td>{{ manual.filename }}</td>
                        <td>{{ manual.description }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="visibleCourseMaterials.length > 0" class="nopads">
                <h4>{{ $t('about.course_materials') }}</h4>
                <table class="table table-hover table-responsive" style="background: #ffffff; cursor: pointer">
                    <thead><tr>
                        <th style="width: 50%">{{ $t('about.manual_title') }}</th>
                        <th style="width: 50%">{{ $t('about.description') }}</th>
                    </tr></thead>
                    <tbody>
                    <tr v-for="(manual, index) in visibleCourseMaterials" :key="index" @click="openFileFromAssets(manual)">
                        <td>{{ manual.filename }}</td>
                        <td>{{ manual.description }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="visibleGdprDocs.length > 0" class="nopads">
                <h4>{{ $t('about.privacy_policy_title') }}</h4>
                <span>{{ $t('about.privacy_hint') }}</span>
                <table class="table table-hover table-responsive" style="background: #ffffff; cursor: pointer">
                    <thead><tr>
                        <th style="width: 50%">{{ $t('about.manual_title') }}</th>
                        <th style="width: 50%">{{ $t('about.description') }}</th>
                    </tr></thead>
                    <tbody>
                    <tr v-for="(manual, index) in visibleGdprDocs" :key="index" @click="openFileFromAssets(manual)">
                        <td>{{ manual.filename }}</td>
                        <td>{{ manual.description }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <h3>{{ $t('about.licenses') }}</h3>
            <h4>Leaflet WMS Header</h4>
            <pre>
BSD 2-Clause License

Copyright (c) 2018, Ticinum Aerospace Srl
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </pre>
        </div>
    </tool-panel>
</template>

<script>
import pdfManual1 from "../assets/Routa Ajoneuvo - Virranhallintaohje.pdf";
import pdfManual2 from "../assets/Routa Ajoneuvo - Pikaohje.pdf";
import pdfManual3 from "../assets/Routa Forest - Käyttöohje.pdf";
import pdfManual4 from "../assets/Routa Paving - Käyttöohje.pdf";
import pdfManual5 from "../assets/Routa Web-Käyttöohje-Asema.pdf";
import pdfManual6 from "../assets/Routa Web-Käyttöohje-Peruskäyttäjä.pdf";
import pdfManual7 from "../assets/Routa Web-Käyttöohje-Työnjohto.pdf";
import pdfManual8 from "../assets/Routa Liikennemerkit - Käyttöohje.pdf";
import pdfManual9 from "../assets/Routa Ajoneuvo - Käyttöohje.pdf";
import pdfManual10 from "../assets/Routa Web-Käyttöohje-Pääkäyttäjä.pdf";
import pdfManual11 from "../assets/Routa-Tilausgeometriat_202404.pdf";
import pdfManual12 from "../assets/Routa Ajoneuvo - Peruskoulutus 2024.pdf";
import pdfManual13 from "../assets/Routa Ajoneuvo - Jatkokoulutus 2024.pdf";
import pdfManual14 from "../assets/Routa - ELY Urakat 2024.pdf";
import pdfManual15 from "../assets/Routa - ELY Urakan Perustaminen 2024.pdf";
import gdprDocument1 from "../assets/Routa-UKK_20240209.pdf";
import gdprDocument2 from "../assets/Routa - Tietosuojaseloste - MALLI.pdf";
import svDocument1 from "../assets/Routa Fordon - Grundutbildning 2025.pdf";
import svDocument2 from "../assets/Routa Fordon - Fortsättningsutbildning 2025.pdf";
import svDocument3 from "../assets/Routa Web - Grundutbildning 2025.pdf";
import svDocument4 from "../assets/Routa Web-Instruktioner-Arbetsledning.pdf";
import ToolPanel from './toolbar/ToolPanel.vue'
import ToolPanelHeader from './toolbar/ToolPanelHeader.vue'

export default {
    name: 'AboutPanel',
    components: { ToolPanel, ToolPanelHeader },
    emits: ['close'],
    data() {
        return {
            pdfManualsMobile: [
                {filename: 'Routa Ajoneuvo - Käyttöohje', description: this.$t('about.vehicle_app'), link: pdfManual9},
                {filename: 'Routa Ajoneuvo - Virranhallintaohje', description: this.$t('about.power_management'), link: pdfManual1},
                {filename: 'Routa Ajoneuvo - Pikaohje', description: this.$t('about.vehicle_quick_guide'), link: pdfManual2},
                {filename: 'Routa Forest - Käyttöohje', description: this.$t('about.forest_app'), link: pdfManual3},
                {filename: 'Routa Paving - Käyttöohje', description: this.$t('about.paving_app'), link: pdfManual4},
                {filename: 'Routa Liikennemerkit - Käyttöohje', description: this.$t('about.signs_app'), link: pdfManual8},
            ],
            pdfManualsBrowser: [
                {filename: 'Routa Web - Käyttöohje-Peruskäyttäjä', description: this.$t('about.web_worker'), link: pdfManual6},
                {filename: 'Routa Web - Käyttöohje-Työnjohto', description: this.$t('about.web_supervisor'), link: pdfManual7},
                {filename: 'Routa Web - Käyttöohje-Asema', description: this.$t('about.web_station'), link: pdfManual5},
                {filename: 'Routa Web - Käyttöohje-Pääkäyttäjä', description: this.$t('about.superuser'), link: pdfManual10},
            ],
            courseMaterials: [
                {filename: 'Routa Ajoneuvo - Peruskoulutus', description: this.$t('about.vehicle_basic'), link: pdfManual12},
                {filename: 'Routa Ajoneuvo - Jatkokoulutus', description: this.$t('about.vehicle_advanced'), link: pdfManual13},
                {filename: 'Routa - ELY-urakat', description: this.$t('about.ely_contracts'), link: pdfManual14},
                {filename: 'Routa Ajoneuvo - ELY-urakan perustaminen', description: this.$t('about.create_ely_contract'), link: pdfManual15},
                {filename: 'Routa Web - Tilausgeometriat', description: this.$t('about.order_geometries'), link: pdfManual11},
            ],
            gdprDocuments: [
                {filename: 'Routa-Tietosuoja UKK', description: this.$t('about.privacy_faq'), link: gdprDocument1},
                {filename: 'Routa-Tietosuojaseloste_20210110', description: this.$t('about.privacy_template'), link: gdprDocument2},
            ]
        }
    },
    computed: {
        visibleMobileManuals() {
            return this.$i18n.locale === 'sv' ? [] : this.pdfManualsMobile
        },
        visibleWebManuals() {
            if (this.$i18n.locale === 'sv') {
                return [{filename: 'Routa web för handledare', description: this.$t('about.web_supervisor'), link: svDocument4}]
            }
            return this.pdfManualsBrowser
        },
        visibleCourseMaterials() {
            if (this.$i18n.locale === 'sv') {
                return [
                    {filename: 'Routa Fordon - Grundutbildning', description: this.$t('about.vehicle_basic'), link: svDocument1},
                    {filename: 'Routa Fordon - Fortsättningsutbildning', description: this.$t('about.vehicle_advanced'), link: svDocument2},
                    {filename: 'Routa web för handledare - Grundutbildning', description: this.$t('about.web_supervisor'), link: svDocument3}
                ]
            }
            return this.courseMaterials
        },
        visibleGdprDocs() {
            return this.$i18n.locale === 'sv' ? [] : this.gdprDocuments
        }
    },
    methods: {
        openFileFromAssets(record) {
            window.open(record.link, '_blank')
        }
    }
}
</script>

<style scoped>
.about-body {
    flex: 1;
    overflow-y: auto;
    padding: 1em 1.2em;
    background: #e8e8e8;
}

h4 {
    font-size: 1.1em;
    font-weight: bold;
    padding-top: .5em;
    color: #052f5b;
    text-transform: uppercase;
}
</style>
